import apiClient from './apiClient';

export const googleAuthApi = {
  // Status prüfen
  getStatus: async () => {
    const response = await apiClient.get('/auth/google/status');
    return response.data;
  },

  // Auth URL holen
  getAuthUrl: async () => {
    const response = await apiClient.get('/auth/google');
    return response.data;
  },

  // Verbindung trennen
  disconnect: async () => {
    const response = await apiClient.delete('/auth/google');
    return response.data;
  }
};
